import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { Subscription, combineLatest, of } from 'rxjs';

import { ReportQuery, ReportQueryService } from '../../../services/report-query';
import { DashboardWidgetLayout } from '../dashboard-grid/dashboard-grid';
import {
  DashboardColor,
  DashboardIcon,
  DashboardValueFormat,
  dashboardErrorMessage,
  dashboardLayoutStyle,
  formatDashboardValue,
  loadDashboardScalar,
} from '../../widget-and-graphs.models';

@Component({
  selector: 'app-dashboard-number-widget',
  standalone: false,
  templateUrl: './dashboard-number-widget.html',
  styleUrl: './dashboard-number-widget.scss',
})
export class DashboardNumberWidget implements OnChanges, OnDestroy {
  @Input() iconSvg = '';
  @Input({ required: true }) query!: ReportQuery;
  @Input() label = '';
  @Input() subtextQuery?: ReportQuery;
  @Input() subtext = '';
  @Input() valueFormat: DashboardValueFormat = 'number';
  @Input() valueMultiplier = 1;
  @Input() subtextFormat: DashboardValueFormat = 'number';
  @Input() icon: DashboardIcon = 'money';
  @Input() color: DashboardColor = 'primary';
  @Input() currencyCode = 'USD';
  @Input() locale = 'en-US';
  @Input() layout: DashboardWidgetLayout = { xs: { width: 12, height: 2 } };

  loading = false;
  error = '';
  value = '0';
  subtextValue = '';
  private request?: Subscription;

  constructor(
    private readonly reportQuery: ReportQueryService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  @HostBinding('attr.style')
  get layoutStyles(): string {
    return dashboardLayoutStyle(this.layout);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['query'] || changes['subtextQuery'] || changes['valueMultiplier']) this.load();
  }

  ngOnDestroy(): void {
    this.request?.unsubscribe();
  }

  private load(): void {
    this.request?.unsubscribe();
    this.error = '';
    if (!this.query) return;
    this.loading = true;
    this.request = combineLatest([
      loadDashboardScalar(this.reportQuery, this.query, 'number'),
      this.subtextQuery
        ? loadDashboardScalar(this.reportQuery, this.subtextQuery, 'number')
        : of(undefined),
    ]).subscribe({
      next: ([primary, secondary]) => {
        this.value = formatDashboardValue(Number(primary.value) * this.valueMultiplier, this.valueFormat, this.currencyCode, this.locale);
        this.subtextValue = secondary
          ? formatDashboardValue(secondary.value, this.subtextFormat, this.currencyCode, this.locale)
          : '';
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.error = dashboardErrorMessage(error);
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }
}
